import { ThemeKeys } from 'teacher-ui-client/utils/themes'

export function classesForTheme(theme?: ThemeKeys) {
  switch (theme) {
    case ThemeKeys.blue:
      return {
        text: 'text-oceany-blue-350',
        background: {
          light: 'bg-oceany-blue-100',
          mid: 'bg-oceany-blue-150',
          dark: 'bg-oceany-blue-250',
        },
      } as const
    case ThemeKeys.green:
      return {
        text: 'text-ms-green-350',
        background: {
          light: 'bg-ms-green-100',
          mid: 'bg-ms-green-150',
          dark: 'bg-ms-green-250',
        },
      } as const
    case ThemeKeys.darkBlue:
      return {
        text: 'text-wl-blue-300',
        background: {
          light: 'bg-wl-blue-100',
          mid: 'bg-wl-blue-150',
          dark: 'bg-wl-blue-250',
        },
      } as const
    default:
      return {
        text: 'text-dusty-black-250',
        background: {
          light: 'bg-dusty-black-100',
          mid: 'bg-dusty-black-150',
          dark: 'bg-dusty-black-250',
        },
      } as const
  }
}
